export class DummyPageAccessConstants {
  static EMAILS = [
    'coskun88arda@gmail.com',
    'harisios.kodonas@avitium.io',
    'alois.leyrer@avitium.io',
    'admin@avitium.io'
  ];
}
